import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { ConversationIndex } from '../conversations/conversation-index/conversation-index.type';

export const useActivityFeedStore = defineStore(
  'activityFeed',
  () => {
    // Message Count
    const unreadMessageCount = ref(0);
    const unreadMessageCountPollingIntervalId = ref<number | null>(null);
    const unreadMessageCountPollingIntervalMs = ref(60000 * 2); // 2 minutes

    // Message List
    const unreadMessages = ref<ConversationIndex[]>([]);
    const page = ref(1);
    const itemsPerPage = ref(25);
    const loadingMessages = ref(false);

    // alphabetized list
    return {
      itemsPerPage,
      loadingMessages,
      page,
      unreadMessageCount,
      unreadMessageCountPollingIntervalId,
      unreadMessageCountPollingIntervalMs,
      unreadMessages,
    };
  },
  {
    persist: false,
  },
);
